export type PublisherCCUChartPoint = {
  day: string; // YYYY-MM-DD (UTC)
  total_avg_ccu: number;
  top_games?: Array<{
    rank: number;
    appid: number;
    name: string;
    avg_online: number;
  }> | null;
};

type GetPublisherCCUChartParams = {
  clanid: number;
  from?: string | null; // YYYY-MM-DD
  to?: string | null; // YYYY-MM-DD
  bust?: number;
  init?: RequestInit;
};

export async function getPublisherCCUChart({
  clanid,
  from,
  to,
  bust,
  init,
}: GetPublisherCCUChartParams): Promise<PublisherCCUChartPoint[]> {
  const searchParams = new URLSearchParams();
  if (from) searchParams.set("from", from);
  if (to) searchParams.set("to", to);
  if (bust != null) searchParams.set("bust", String(bust));

  const url = `/api/publisher/${clanid}/ccu/chart${
    searchParams.size ? `?${searchParams.toString()}` : ""
  }`;

  const response = await fetch(url, { cache: "no-store", ...init });
  const payload = (await response.json()) as { error?: string } | unknown;

  if (!response.ok) {
    throw new Error(
      (payload as { error?: string })?.error ??
        "Failed to fetch publisher CCU chart"
    );
  }

  return (payload as PublisherCCUChartPoint[]) ?? [];
}
